export interface AvailableAdditionalFileTypes {
    InterchangeInAdditionalFileTypes: AvailableAdditionalFileType[],
    DocumentAdditionalFileTypes: AvailableAdditionalFileType[],
    InterchangeOutAdditionalFileTypes: AvailableAdditionalFileType[]
}

export interface AvailableAdditionalFileType {
    FileType: string,
    AvailableAdditionalFileTypeStatus: AvailableAdditionalFileTypeStatus
}

export enum AvailableAdditionalFileTypeStatus {
    Unknown = 'Unknown',
    Valid = 'Valid',
    MissingInstances = 'MissingInstances',
    MultipleInstances = 'MultipleInstances',
    TooManyDocuments = 'TooManyDocuments',
    FileUnavailable = 'FileUnavailable',
    ContainsResentDocument = 'ContainsResentDocument'
}